import memoize from 'lru-memoize';
import {
  createValidator,
  required,
  money,
  email,
  minLength,
  maxLength,
} from '../../utils/validation';

const paymentValidation = createValidator({
  companyName: required,
  address: required,
  city: required,
  state: required,
  zipCode: required,
  routingNumber: [required, minLength(9), maxLength(9)],
  accountNumber: required,
  accountType: required,
  bankName: required,
  submittedByName: required,
  submittedByEmail: [required, email],
  amount: [required, money],
  depositType: required,
});
export default memoize(10)(paymentValidation);
